import { ReceiptIcon as PhosphorReceiptIcon } from "@phosphor-icons/react/dist/ssr/Receipt";

import { createAppIcon } from "@/components/createAppIcon";

export const PriceCheckIcon = /* @__PURE__ */ createAppIcon(PhosphorReceiptIcon);
export const ReceiptIcon = /* @__PURE__ */ createAppIcon(PhosphorReceiptIcon);
